import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMixingPath = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 260,
	height: 100,
	viewBox: "0 0 260.0 100.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 260,
		height: 100,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 10.0 40.0 L 10.0 10.0 L 75.0 90.0 L 75.0 60.0 M 90.0 40.0 L 90.0 10.0 L 155.0 90.0 L 155.0 60.0 M 170.0 40.0 L 170.0 10.0 L 235.0 90.0 L 235.0 60.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgMixingPath;
